import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
var EnvironmentManagerService = /** @class */ (function () {
    function EnvironmentManagerService() {
        this.subject = new Subject();
        var lsValue = localStorage.getItem('enviroment');
        if (lsValue && (lsValue === 'production' || lsValue === 'stage')) {
            this.setCurrentEnvironment(lsValue);
        }
        else {
            this.setCurrentEnvironment('production');
        }
    }
    EnvironmentManagerService.prototype.getEnvironmentChangedListener = function () {
        return this.subject.asObservable();
    };
    EnvironmentManagerService.prototype.switchEnvironment = function (current) {
        if (current === 'stage') {
            return this.setCurrentEnvironment('production');
        }
        else if (current === 'production') {
            return this.setCurrentEnvironment('stage');
        }
    };
    EnvironmentManagerService.prototype.getCurrentEnvironment = function () {
        return this.currentEnvironment;
    };
    EnvironmentManagerService.prototype.getOtherEnvironment = function () {
        return this.currentEnvironment === 'stage' ? 'production' : 'stage';
    };
    EnvironmentManagerService.prototype.setCurrentEnvironment = function (current) {
        this.currentEnvironment = current;
        this.subject.next(this.currentEnvironment);
        localStorage.setItem('enviroment', this.currentEnvironment);
        return this.currentEnvironment;
    };
    EnvironmentManagerService.ngInjectableDef = i0.defineInjectable({ factory: function EnvironmentManagerService_Factory() { return new EnvironmentManagerService(); }, token: EnvironmentManagerService, providedIn: "root" });
    return EnvironmentManagerService;
}());
export { EnvironmentManagerService };
